import { useQuery } from '@tanstack/react-query';

import { fetchComparator } from '../api/FetchComparator';

export function useFetchComparator(renewalUuid: string) {
  const { data, isLoading } = useQuery({
    queryKey: ['comparator', renewalUuid],
    queryFn: () => fetchComparator(renewalUuid),
    throwOnError: true,
  });

  return {
    currentYear: data?.currentYear ?? '',
    lastYear: data?.lastYear ?? '',
    situations: data?.situations ?? [],
    isLoading,
  };
}
